import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=903e4c46&lang=pug&"
import script from "./DesktopMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports